export default __webpack_public_path__ + "static/company-at-work-0e2a226101fe21d710309cf10cd50b15.png";